(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/utils/map-error-dialogs.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/utils/map-error-dialogs.js');

'use strict';

const mapErrorDialog = () => {
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ALERT,
    icon: 'exclamation-sign',
    title: 'Karttjänsten ur funktion',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Just nu går det inte att använda kartan. <br/> Försök igen om en stund'
    }],
    actions: [{
      title: 'Jag förstår',
      callback: (e, forms, dialog) => {
        dialog.close(() => {
          svs.utils.url.navigate(svs.core.urlMapping.get('lyckoplatsenHome'));
        });
      }
    }]
  }));
};
const mapErrorDialogNoRedirect = () => {
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ALERT,
    icon: 'exclamation-sign',
    title: 'Karttjänsten ur funktion',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Just nu går det inte att använda kartan. <br/> Försök igen om en stund'
    }],
    actions: [{
      title: 'Jag förstår',
      callback: (e, forms, dialog) => {
        dialog.close();
      }
    }]
  }));
};
setGlobal('svs.lyckoplatsen.shared_map.utils', {
  mapErrorDialog,
  mapErrorDialogNoRedirect
});

 })(window);